import { useTranslation } from 'react-i18next';

/**
 * Fallback UI shown by the Bugsnag React ErrorBoundary after an uncaught render error.
 * Keeps the surface token-based and i18n’d so users can recover with a full reload.
 */
export function BugsnagErrorFallback() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-background p-5 text-center text-muted-foreground">
      <h2 className="text-lg font-semibold text-foreground">{t('common.errorBoundaryTitle')}</h2>
      <p>{t('common.errorBoundaryMessage')}</p>
      <button
        type="button"
        className="cursor-pointer rounded-md border-0 bg-primary px-5 py-2.5 text-primary-foreground"
        onClick={() => {
          window.location.reload();
        }}
      >
        {t('common.errorBoundaryRefresh')}
      </button>
    </div>
  );
}
